import { render, staticRenderFns } from "./SkillConfigDialog.vue?vue&type=template&id=3917cb6b&scoped=true&"
import script from "./SkillConfigDialog.vue?vue&type=script&lang=js&"
export * from "./SkillConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917cb6b",
  null
  
)

export default component.exports